<script setup lang="ts">
import { PropType, computed, inject } from 'vue'
import { AppSettingsKey } from './../../types/keys'
import type { Departure, TranslatedField, AppSettings, CurrentCulture } from '../../types'

const props = defineProps({
  journeyTimeText: {
    type: Object as PropType<TranslatedField>,
    required: true
  },
  journeyTimeTextSuffix: {
    type: Object as PropType<TranslatedField>,
    required: true
  },
  departure: {
    type: Object as PropType<Departure>,
    required: true,
  },
  currentCulture: {
    type: Object as PropType<CurrentCulture>,
    required: true,
  },
})

const { resourceStrings } = inject(
  AppSettingsKey
) as AppSettings

const statusClass = computed<string>(() => {
  switch (props.departure.statusColour) {
    case 'red':
      return 'departure__b-r--warning'
    case 'green':
      return 'departure__b-r--success'
    default:
    case 'default':
      return 'departure__b-r--info'
  }
})

</script>
<template>
  <div class="departure">
    <div class="departure__t">
      <div class="departure__t-l">
        {{ departure.departureTimeDisplayText }}
        <span class="departure__t-l-cc">{{
          departure.departureTimeZoneDisplayText
        }}</span>

        <template v-if="departure.arrivalTimeDisplayText && departure.arrivalTimeDisplayText.trim() !== ''">
          <svg class="departure__t-l-d" aria-hidden="true">
            <use href="#svg-button-arrow"></use>
          </svg>
          {{ departure.arrivalTimeDisplayText }}
          <span class="departure__t-l-cc">
            {{ departure.arrivalTimeZoneDisplayText }}
          </span>
          <span class="departure__t-l-dt">
            <strong>{{ journeyTimeText[currentCulture.cultureShortCode] }}</strong>
            {{ journeyTimeTextSuffix[currentCulture.cultureShortCode] }}
          </span>
        </template>

        <template v-else>
            <span class="departure__t-l-tbc">
                {{ resourceStrings['TravelUpdates.Labels.DepartureTime'] }} {{ resourceStrings['TravelUpdates.Labels.ToBeConfirmed'] }}
            </span>
        </template>
      </div>
      <div class="departure__t-r">{{ resourceStrings['TravelUpdates.Labels.Status']}}</div>
    </div>
    <div class="departure__b">
      <div class="departure__b-l">{{ departure.letter }}</div>
      <div :class="['departure__b-r', statusClass]">
        {{ departure.status[currentCulture.cultureShortCode] }}
      </div>
    </div>
  </div>
</template>
